import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    company_name: "",
    email: "",
    password: "",
  });
  const [error, setError] = useState("");

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await register(form);
      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.detail || "Registration failed.");
    }
  };

  return (
    <form onSubmit={submit} className="card mx-auto max-w-sm space-y-4 p-6">
      <h1 className="text-2xl font-extrabold">Create an account</h1>
      <p className="text-sm text-gray-500">
        For businesses placing repeat promotional orders.
      </p>
      <div>
        <label className="label">Your name</label>
        <input className="input" required value={form.name} onChange={set("name")} />
      </div>
      <div>
        <label className="label">Company name</label>
        <input className="input" value={form.company_name} onChange={set("company_name")} />
      </div>
      <div>
        <label className="label">Email</label>
        <input type="email" className="input" required value={form.email} onChange={set("email")} />
      </div>
      <div>
        <label className="label">Password</label>
        <input
          type="password"
          className="input"
          required
          minLength={6}
          value={form.password}
          onChange={set("password")}
        />
      </div>
      {error && <p className="text-sm text-red-600">{error}</p>}
      <button className="btn-primary w-full">Create account</button>
      <p className="text-center text-sm text-gray-500">
        Already have an account?{" "}
        <Link to="/login" className="font-semibold text-fairway-700">
          Log in
        </Link>
      </p>
    </form>
  );
}
